import script from "./BalBreakdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalBreakdown.vue?vue&type=script&setup=true&lang=ts"

import "./BalBreakdown.vue?vue&type=style&index=0&id=3272b7ee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3272b7ee"]])

export default __exports__